/* istanbul ignore file */
import { FieldProps } from 'framework/ui/field';
import { InvoiceTotalField } from 'domain/shared/core/invoice';

const PurchaseOrderTotalField = ({ source, ...props }: FieldProps & { isVisible?: boolean }) => {
  return (
    <InvoiceTotalField
      source={source}
      currencySource={source as string}
      formatAmount={subTotal => subTotal?.amount}
      formatCurrency={subTotal => subTotal?.currency}
      {...props}
    />
  );
};

export default PurchaseOrderTotalField;
